module.exports = __webpack_public_path__ + "img/home-calculadora.36ac9a5d.png";